import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./../assets/styles/css/HistoryMoviePage.css";
import { getMovieDetail } from "../api/movieApi";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";

const HistoryMoviePage = () => {
  const [history, setHistory] = useState([]);
  const [movieDetails, setMovieDetails] = useState({});
  const navigate = useNavigate();
  const MAX_SAVE_DAYS = 7;
  const extractMovieSlug = (key) => {
    const match = key.match(/videoTime_(.*?)_.*/);
    return match ? match[1] : "";
  };

  const formatEpisode = (slug) => {
    const match = slug.match(/tap-(\d+)/);
    return match ? `Tập ${match[1].padStart(2, "0")}` : slug;
  };

  useEffect(() => {
    const loadHistory = () => {
      const historyData = [];
      const now = Date.now();
    
      for (const key in localStorage) {
        if (key.startsWith("videoTime_")) {
          try {
            const data = JSON.parse(localStorage.getItem(key));
            if (data && data.time !== undefined) {
              const movieSlug = extractMovieSlug(key);
              const episodeSlug = key.split("_").pop();
              
              if (!data.timestamp || isNaN(data.timestamp)) {
                data.timestamp = now;
                localStorage.setItem(key, JSON.stringify(data));
              }
    
              if (now - data.timestamp > MAX_SAVE_DAYS * 24 * 60 * 60 * 1000) {
                localStorage.removeItem(key);
              } else {
                historyData.push({
                  movieSlug,
                  episodeSlug,
                  time: data.time,
                  timestamp: data.timestamp,
                });
              }
            }
          } catch (error) {
            console.error("Lỗi parsing dữ liệu từ localStorage:", error);
          }
        }
      }
    
      historyData.sort((a, b) => b.timestamp - a.timestamp);
      setHistory(historyData);
    };    

    loadHistory();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchMovieDetails = async () => {
      const movieInfo = {};
      for (const item of history) {
        if (!movieDetails[item.movieSlug]) {
          try {
            const response = await getMovieDetail(item.movieSlug);
            movieInfo[item.movieSlug] = response.data.movie;
          } catch (error) {
            console.error(`Lỗi tải chi tiết phim ${item.movieSlug}:`, error);
          }
        }
      }
      setMovieDetails((prev) => ({ ...prev, ...movieInfo }));
    };

    if (history.length > 0) {
      fetchMovieDetails();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  const handleContinueWatching = (movieSlug, episodeSlug) => {
    const now = Date.now();
    history.forEach((item) => {
      if (now - item.timestamp > MAX_SAVE_DAYS * 24 * 60 * 60 * 1000){
        localStorage.removeItem(`videoTime_${item.movieSlug}_${item.episodeSlug}`);
      }
    });
    setHistory((prevHistory) =>
      prevHistory.filter((item) => now - item.timestamp <= MAX_SAVE_DAYS)
    );

    navigate(`/phim/${movieSlug}/${episodeSlug}`);
  };

  return (
    <div className="history-movie-page">
      <Breadcrumb />
      <h1 className="name-sort">Lịch sử xem phim</h1>
      {history.length === 0 ? (
        <p></p>
      ) : (
        <ul className="custom-list-history">
          {history.map((item, index) => {
            const movie = movieDetails[item.movieSlug];
            return (
              <li key={index} className="history-item">
                {movie && (
                  <img src={movie.poster_url} alt={movie.title} className="skeleton-image" style={{ width: "180px"}} />
                )}
                <div>
                  <span className="movie-title">
                    {movie ? movie.name : item.movieSlug.replace(/-/g, " ")} - {" "}
                    {formatEpisode(item.episodeSlug)}
                  </span>
                  <span className="watch-time">
                    Đã xem: {Math.floor(item.time / 60)} phút, {new Date(item.timestamp).toLocaleString()}
                  </span>
                  <button className="bnt-history" onClick={() => handleContinueWatching(item.movieSlug, item.episodeSlug)}>
                    <img src="/default-placeholder.svg" alt="Trailer Thumbnail" /> Xem tiếp
                  </button>       
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default HistoryMoviePage;